import { IJsonQuery } from './types/jsonQuery';
import { setGeo } from './helpers';

export function clearGeo(jsonQuery: IJsonQuery): () => IJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
